import {Component, OnInit} from '@angular/core';
import {AbstractBffApi, KeystringValueInterface, NewsInterface} from '../../../models/sharedinterface';
import {ApiFactoryService} from '../../../shared/services/api-factory.service';
import {ShareddataService} from '../../../shared/services/shareddata.service';
import {Router} from '@angular/router';
import {GlobalsService} from '../../../shared/services/globals.service';
import {AuthenticationService} from '../../../security/authentication.service';
import { HostListener } from '@angular/core';

@Component({
  selector: 'app-main-landing',
  templateUrl: './main-landing.component.html',
  styleUrls: ['./main-landing.component.scss']
})
export class MainLandingComponent implements OnInit {

  currentNews: NewsInterface[];
  currentlanguage: KeystringValueInterface;
  bffapi: AbstractBffApi;
  isloggedin: boolean;
  screenHeight: number;

  constructor(
    private apifactory: ApiFactoryService,
    private shareddata: ShareddataService,
    private globalsservice: GlobalsService,
    private authservice: AuthenticationService,
    public router: Router,
  ) {
    this.bffapi = this.apifactory.createBffApi();

    this.shareddata.currentlanguage$.subscribe(async (data) => {

      if (this.currentlanguage && this.currentlanguage.value === data.value) {
        return;
      }

      // update language
      this.currentlanguage = data;

      if (this.isloggedin) {
        // gets the news in the new language
        const response = await this.bffapi.getmandantnews2(this.currentlanguage.key).toPromise();
        this.currentNews = response.results;
      }
    });

    this.authservice.isloggedin$.subscribe(async (data) => {
      this.isloggedin = data;

      if (this.isloggedin && this.currentlanguage) {
        // get the news
        const response = await this.bffapi.getmandantnews2(this.currentlanguage.key).toPromise();
        this.currentNews = response.results.sort((a, b) => {
          // order news by event date, most recent first
          return Date.parse(b.newseventdate) - Date.parse(a.newseventdate);
        });
      }
    });

    this.onResize();
  }

  ngOnInit(): void {
  }

  convertDate(dateobject) {
    return this.globalsservice.convertDateFormatFromDb(dateobject, 'DD.MM.YYYY');
  } // convertDate

  getNewsPosition() {
    // force news placement in the center if the resolution is too low
    if (this.screenHeight < 620) {
      return 'center';
    }
    return this.shareddata.getNewsPosition();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    this.screenHeight = window.innerHeight;
  }

}
